module.exports = __webpack_public_path__ + "img/9788932909059.2f4a429c.jpg";